<template>
  <div>
    <CustomDialog
      :show="show"
      :title="$t('public.editNtrip')"
      @toggleShow="handleClose"
      :appendToBody="true"
      width="800"
    >
      <div slot="main">
        <div class="info">
          <el-form
            :model="form"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="170px"
            class="demo-ruleForm"
            size="small"
          >
            <el-form-item :label="$t('public.username')" prop="username">
              <el-input
                disabled
                v-model="form.username"
                autocomplete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.password')" prop="password">
              <el-input
                type="password"
                show-password
                v-model="form.password"
                autocomplete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.online')" prop="online">
              <el-input v-model="form.online" autocomplete="off" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.auth')" prop="station">
              <el-transfer
                filterable
                :filter-method="filterMethod"
                :filter-placeholder="$t('public.p3')"
                v-model="stationsValue"
                :data="data"
                @change="transferChange"
              >
              </el-transfer>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <div class="btns">
          <el-button
            @click="confirm"
            type="primary"
            size="small"
            style="width: 100%"
            >{{ $t("public.submit") }}</el-button
          >
          <el-button @click="handleClose" size="small" style="width: 100%">{{
            $t("public.cancel")
          }}</el-button>
        </div>
      </div>
    </CustomDialog>
  </div>
</template>
  
  <script>
import { updateUser, getStations } from "@/api/index";
import CustomDialog from "../../../components/public/customDialog";
export default {
  name: "OverseasStationManageViewList",
  components: {
    CustomDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "view",
    },
  },
  data() {
    return {
      data: [],
      stations: [], // 授权基站列表
      searchKey: [], // 搜索关键字
      stationsValue: [], // 已经选择的
      filterMethod(query, item) {
        return item.searchKey.indexOf(query) > -1;
      },
      form: {
        username: "",
        password: "",
        online: "",
      },
      rules: {
        username: [
          { required: true, message: this.$t('public.ver1'), trigger: "blur" },
        ],
        password: [{ required: true, message: this.$t('public.ver2'), trigger: "blur" }],
        online: [
          { required: true, message: this.$t('public.ver4'), trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    rowInfo: {
      handler(newV, oldV) {
        if (newV) {
          console.log(newV, "newV");
          this.form.username = newV.name;
          this.form.password = newV.password;
          this.form.online = newV.cnum;
          this.stationsValue = newV.stations;
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.generateData();
    this.getGroup();
  },

  methods: {
    async getGroup() {
      getStations().then((res) => {
        console.log(res, "resss");
        this.stations = res.data.map((item) => {
          return item.nm;
        });
        this.searchKey = this.stations;
        this.generateData();
      });
    },
    transferChange(e) {
      console.log(e, "eeee");
    },
    generateData() {
      this.stations.forEach((item, index) => {
        this.data.push({
          label: item,
          key: item,
          searchKey: this.searchKey[index],
        });
      });
    },
    confirm() {
      let param = {
        username: this.form.username,
        password: this.form.password,
        limit: Number(this.form.online),
        stations: this.stationsValue.join("|"),
      };
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          // console.log(param)
          updateUser(param).then((res) => {
            if (res.code == 200) {
              this.handleClose();
              this.$emit("refush");
              this.$message.success(this.$t('public.success1'));
            }
          });
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.$emit("update:show", false);
    },
  },
};
</script>
  <style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>